<template>
    <div class="console">
        <div class="hello">
            <div class="l">
                <img src="https://i.gtimg.cn/club/item/face/img/2/16022_100.gif" alt="">
            </div>
            <div class="r">
                <div class="t">您好{{name}}！欢迎登录车险人伤系统。</div>
                <div class="b">最近更新：无。</div>
            </div>
        </div>

        <div style="margin-top:20px">
            <el-date-picker
                v-model="searchDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small">
            </el-date-picker>
            <el-button type="primary" size="small" @click="queryPiccHumanNumber()">查询</el-button>
        </div>

        <el-row>
            <el-col :lg="9" :md="16" :sm="24">
                <div class="echart">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            案件量
                        </div>
                        <div class="r">
                            <el-button type="primary" size='mini' icon="el-icon-upload" style="margin-right:15px" @click="pushCase">推送</el-button>
                            <el-tag type="success">
                                日
                            </el-tag>
                        </div>
                        
                    </div>
                    <div class="content" ref="visit" id="visit"></div>
                </div>
            </el-col>

            
        </el-row>
        
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'console',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            visitChart:null,
            name:localStorage.getItem('name'),
            tableData:[],
            searchDate:'',
            numData:{},
        }
    },
    created(){
        this.queryPiccHumanNumber();

    },
    mounted(){
        let _this = this;
        window.onresize = function(){
            _this.initVisitChart();
        }
    },
    methods:{
        async pushCase(){
            let res = await api.queryPiccHumanRequest(this.numData.exceptcase);
            if(res.data.code == '200'){
                this.queryPiccHumanNumber();
            }
        },
        async queryPiccHumanNumber(){
            let query = {};
            if(this.searchDate&&this.searchDate.length>0){
                query.startTime = this.searchDate[0];
                query.endTime = this.searchDate[1];
            }else{
                query = {}
            }
            let res = await api.queryPiccHumanNumber(query)
            this.numData = res.data.data;
            this.initVisitChart();
        },
        initVisitChart(){
            let option = {
                
                xAxis: {
                    type: 'category',
                    data: ['车务系统人伤案件数量', '人伤系统案件数量'],
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    type: 'value'
                },
                grid: {
                    top:'15% ',
                    bottom:'15% ',
                    left: '20% '
                },
                 tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                series: [{
                    name:'车务系统人伤案件数量',
                    data: [this.numData.carsystemnum,''],
                    type: 'bar',
                    stack: 'Total',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#83bff6'},
                                {offset: 0.5, color: '#188df0'},
                                {offset: 1, color: '#188df0'}
                            ]
                        )
                    },
                },
                {
                    name:'人伤系统案件数量',
                    data: ['',this.numData.cxrssystemnum],
                    type: 'bar',
                    stack: 'Total',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 1, color: '#13ce66'},
                                {offset: 0, color: '#58e7d6'}
                            ]
                        )
                    },
                }
                ]
            };
            this.$nextTick(()=>{
                console.log(this.$refs.visit);
                this.visitChart = this.$echarts.init(this.$refs.visit);
                this.visitChart.clear();
                this.visitChart.setOption(option,true);
                this.visitChart.resize();
            })
        },
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000000;'
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .console{
        padding: 10px;
        .condition{
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            color: #303133;
            display: flex;
            align-items: center;
            min-height: 105px;
            padding: 0 20px;
            transition: .3s;
            .item{
                display: flex;
                align-items: center;
                padding: 7px;
                .label{
                    min-width: 110px;
                }
            }
            .btns{
                display: flex;
                margin-left: 20px;
            }
        }
        .dialog{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                    span{
                        color:red
                    }
                }
                .item-input{
                    width: 300px;
                    display: flex;
                    align-items: center;
                }
                .item-imgs{
                    width: 400px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-left: 10px;
                }
                .item-textarea{
                    width: 400px;
                }
            }
            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
            
        }
        .dialog-a{
            .item{
                font-size: 14px;
                padding:10px 50px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .item-ta{
                width:920px;
                .item-textarea{
                    width: 960px;
                }
            }
            
        }

        .hello{
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            color: #303133;
            display: flex;
            align-items: center;
            min-height: 105px;
            padding: 20px;
            transition: .3s;
            .l{
                width: 60px;
                height: 60px;
                margin-right: 20px;
                border-radius: 50%;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
            }
            .r{
                .t{
                    margin-bottom: 12px;
                    font-size: 20px;
                    font-weight: 700;
                    color: #3c4a54;
                }
                .b{
                    font-size: 14px;
                    color: #808695;
                }
            }
            
        }
        .hello:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
        .echart{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            // min-height: 268px;
            margin-top: 20px;
            position: relative;
            // height: 315px;
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                border-bottom: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .r{
                    width: 100px;
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    border-color: #d0f5e0;
                    color: #13ce66;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .z{
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    background-color: #fff8e6;
                    border-color: #fff1cc;
                    color: #ffba00;
                }
            }
            .content{
                height: 390px;
            }
            .bottom{
                width: 100%;
                position: absolute;
                height: 50px;
                bottom: 0;
                border-top: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                font-size: 14px;
                padding-left: 20px;
            }
        }
        .echart:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }

        .table{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            min-height: 268px;
            margin-top: 20px;
            /deep/.el-table th{
                padding: 7px 0;
            }
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #ebeef5;
            }
            .content{
                height: 360px;
                padding: 15px;
            }
        }
        .table:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
    }
</style>
